// Unified service for all accounting records using reimbursement endpoints
import axios from 'axios';
import { baseUrl_SPB } from '../../BaseUrl';
import { useAuth } from '../../AuthProvider';
// Create or update a record (invoice, expense, etc.)
export const createOrUpdateRecord = async (data, token, isUpdate = false) => {
  const url = isUpdate
    ? `${baseUrl_SPB}/api/v1/reimburse/updatereimbursementall`
    : `${baseUrl_SPB}/api/v1/reimburse/reimbursement`;
  return axios.post(url, data, {
    headers: { 'Authorization': 'Bearer ' + token }
  });
};

// Delete a record by reimbursementId
export const deleteRecord = async (reimbursementId, token) => {
  return axios.get(`${baseUrl_SPB}/api/v1/reimburse/deletereimbursement?reimbursementId=${reimbursementId}`, {
    headers: { 'Authorization': 'Bearer ' + token }
  });
};

// Fetch records by status/type
export const fetchRecords = async (token, status = 'pending', mine = false,companyId='test') => {
  let url = `${baseUrl_SPB}/api/v1/reimburse/retrieveexpenses`;
  if (status === 'approved') url += '/approved';
  if (status === 'rejected') url += '/rejected';
  if (mine) url += '/my';
 
  if (companyId) url += `?companyId=${companyId}`;
  return axios.get(url, {
    headers: { 'Authorization': 'Bearer ' + token }
  });
};
